import React from 'react';

import type { SvgIconClassKey } from '@mui/material';
import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function DottedTocIcon(props: {
  classes?: Partial<Record<SvgIconClassKey, string>>;
}): JSX.Element {
  return (
    <SvgIcon
      classes={props.classes}
      style={{ display: 'block', height: 78, width: 62 }}
      viewBox="0 0 62 78"
    >
      <g fill="none" fillRule="evenodd">
        <rect
          data-toc-card=""
          fill="#FFF"
          height="77"
          rx="3"
          stroke={IconColors.Grey}
          width="61"
          x=".5"
          y=".5"
        />
        <g fill={IconColors.Grey}>
          <rect height="4" rx="2" width="27" x="8" y="14" />
          <rect height="4" rx="2" width="22" x="8" y="28" />
          <rect height="4" rx="2" width="18" x="8" y="42" />
          <rect height="3" rx="1.5" width="46" x="8" y="66" />
        </g>
        <g
          stroke={IconColors.Grey}
          strokeDasharray="1.5 2.5"
          strokeLinecap="round"
          strokeWidth="1.5"
        >
          <path d="M38 16H48" />
          <path d="M33 30H48" />
          <path d="M29 44H48" />
        </g>
        <text
          fill={IconColors.DarkGrey}
          fontFamily="Open Sans"
          fontSize="10"
          fontWeight="500"
          textAnchor="end"
        >
          <tspan x="54" y="19">
            1
          </tspan>
          <tspan x="54" y="33">
            2
          </tspan>
          <tspan x="54" y="47">
            3
          </tspan>
        </text>
      </g>
    </SvgIcon>
  );
}
